// @flow

import * as React from 'react'
import styled, { css } from 'styled-components'
import { classnames } from '@/helpers'
import { Images } from '@/constants'
import { clickOutside } from '@/hoc'
import styles from './styles.scss'
import jsStyles from './styles'

const Input = styled.input`
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${styles.lightGrey};
  ${props =>
    props.success &&
    css`
      border-bottom-color: ${styles.success};
    `}
  ${props =>
    props.error &&
    css`
      border-bottom-color: ${styles.error};
    `}
`

type InputProps = {|
  ariaLabel?: string,
  placeholder: ?string,
  error?: string,
  displayType?: 'horizontal' | 'vertical',
  success?: boolean,
  onChange: (value: ?string) => void,
  clean?: ?(value: string) => void,
  type?:
    | 'button'
    | 'checkbox'
    | 'color'
    | 'date'
    | 'datetime-local'
    | 'email'
    | 'file'
    | 'hidden'
    | 'image'
    | 'month'
    | 'number'
    | 'password'
    | 'radio'
    | 'range'
    | 'reset'
    | 'search'
    | 'submit'
    | 'tel'
    | 'text'
    | 'time'
    | 'url'
    | 'week'
    | 'name',
  name: string,
  dropDown?: ?React.Node,
  onFocus?: ?() => void,
  onBlur?: ?() => void,
  visible?: boolean,
  className?: ?string,
  accessory?: ?string | Object, // identity-obj-proxy
  requestClose?: () => void,
  label?: string,
  dataPrivate?: ?'redact' | 'lipsum',
|}

type InputState = {||}

class SVHInput extends React.Component<InputProps, InputState> {
  static defaultProps = {
    ariaLabel: '',
    type: 'text',
    dropDown: null,
    visible: false,
    error: '',
    success: false,
    clean: null,
    onFocus: null,
    onBlur: null,
    className: null,
    accessory: null,
    label: '',
    requestClose: () => {},
    dataPrivate: null,
    displayType: 'vertical',
  }

  onFocus = () => {
    const { onFocus } = this.props
    if (onFocus) {
      onFocus()
    }
  }

  onBlur = () => {
    const { onBlur } = this.props
    if (onBlur) {
      onBlur()
    }
  }

  onChange = (e: DOMEvent) => {
    e.persist()
    const { onChange, clean } = this.props
    let { value } = e.target
    if (clean && value) {
      value = clean(value)
    }
    onChange(value)
  }

  focus = () => {
    if (this.inputRef) {
      this.inputRef.focus()
    }
  }

  inputRef: ?HTMLInputElement

  renderDropDown = () => {
    const { dropDown, visible } = this.props
    if (visible && dropDown) {
      return dropDown
    }
    return null
  }

  renderAccessory = () => {
    const { accessory, success, error } = this.props
    let imgSrc = null
    let alt = ''
    if (accessory) {
      imgSrc = accessory
      alt = 'accessory'
    } else if (success) {
      imgSrc = Images.success
      alt = 'success'
    } else if (error) {
      imgSrc = Images.error
      alt = 'error'
    }
    if (imgSrc) {
      return (
        <button type="button" onClick={this.focus} className={styles.accessory}>
          <img className={styles.accessory} src={imgSrc} alt={alt} />
        </button>
      )
    }
    return null
  }

  renderError = () => {
    const { error } = this.props
    if (error) {
      return <span className={styles.error}>{error}</span>
    }
    return null
  }

  render() {
    const { className, label, name, dataPrivate, displayType, ...rest } = this.props
    return (
      <div css={jsStyles.flexRow()}>
        <label
          id={label && label.replace(/ /g, '')}
          className={styles.inputLabel}
          htmlFor={name.replace(/ /g, '')}
        >
          {label}
        </label>
        <div className={styles.inputContainer}>
          <Input
            ref={ref => {
              this.inputRef = ref
            }}
            id={name.replace(/ /g, '')}
            name={name}
            className={classnames(styles.baseInput, className)}
            {...rest}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onChange={this.onChange}
            data-private={dataPrivate}
          />
          {this.renderAccessory()}
          {this.renderDropDown()}
        </div>
        {this.renderError()}
      </div>
    )
  }
}

export default clickOutside(SVHInput)
